import { render, staticRenderFns } from "./FloatingCartButton.vue?vue&type=template&id=c8c16cb0&scoped=true"
import script from "./FloatingCartButton.vue?vue&type=script&lang=js"
export * from "./FloatingCartButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingCartButton.vue?vue&type=style&index=0&id=c8c16cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c16cb0",
  null
  
)

export default component.exports